import { render } from "./EmailFormPage.vue?vue&type=template&id=42a4784d&scoped=true"
const script = {}

import "./EmailFormPage.vue?vue&type=style&index=0&id=42a4784d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a4784d"]])

export default __exports__